import classNames from 'classnames/bind';
import styles from './hr.module.sass';

const cx = classNames.bind(styles);

export const Hr = ({ className }) => <div className={cx('hr', className)} />;
